import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const CompanyCreates = (props) => {
    const history = useHistory();

    const [name, setName] = useState("");
    const [companyCode, setCompanyCode] = useState("");
    const [contactNumber1, setContactNumber1] = useState("");
    const [contactNumber2, setContactNumber2] = useState("");
    const [email, setEmail] = useState("");
    const [gstNumber, setGstNumber] = useState("");
    const [website, setWebsite] = useState("");
    const [addressLine, setAddressLine1] = useState("");
    const [addressLine2, setAddressLine2] = useState("");
    const [pincode, setPostcode] = useState("");
    const [city, setCity] = useState("");
    const [district, setDistrict] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [pinCodes, setPinCodes] = useState([]);

    const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchData('PinCodeApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    setPinCodes(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching PIN codes:', error);
            });
    }, []);

    const handlePinCodeChange = (event) => {
        const value = event;
        if (value.length === 6) {
            const selectedPinCode = pinCodes.find(pinCode => pinCode.Postcode === value);
            if (selectedPinCode) {
                setCity(selectedPinCode.City);
                setDistrict(selectedPinCode.District);
                setPostcode(selectedPinCode.Postcode);
                setCountry(selectedPinCode.Country);
                setState(selectedPinCode.State);
            }
        }
    };

    const handleNameChange = (event) => {
        const newName = event.target.value;
        setName(newName);

        // Auto-generate company code (Example: converting "My Company" to "MYC123" with a random number)
        const generatedCode = newName
            .toUpperCase()
            .split(' ')
            .map((word) => word.charAt(0))
            .join('');

        // Add a random number or unique identifier to the generated code
        const randomNumber = Math.floor(100 + Math.random() * 900); // Generates a random 3-digit number
        const finalCode = `${generatedCode}${randomNumber}`;

        setCompanyCode(finalCode);
    };


    const clearForm = () => {
        setName("");
        setCompanyCode("");
        setContactNumber1("");
        setContactNumber2("");
        setEmail("");
        setGstNumber("");
        setWebsite("");
        setAddressLine1("");
        setAddressLine2("");
        setPinCodes("");
        setCity("");
        setDistrict("");
        setState("");
        setCountry("");
    };

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!name || !contactNumber1) {
            setErrorMessage("All fields are required!");
            setIsLoading(false);
            return;
        }

        const CompanyCreateData = {
            Name: name,
            CompanyCode: companyCode,
            ContactNumber1: contactNumber1,
            ContactNumber2: contactNumber2,
            Email: email,
            GSTNumber: gstNumber,
            Website: website,
            Addressline1: addressLine,
            Addressline2: addressLine2,
            Pincode: pincode,
            City: city,
            District: district,
            State: state,
            Country: country,
            CreatedBy: 1,
            CreatedDate: new Date(),
        };

        postData('CompanyApi', CompanyCreateData, token)
            .then((response) => {
                console.log('Company Created success:', response);
                setSuccessMessage("Company Created successful!");
                setErrorMessage("");
                clearForm();
                history.push('/companyIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Company Create error:', error);
                setIsLoading(false);
            });
    };

    /* End API */

    return (

        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={submitData}>

                    <div className='w-full mb-2 flex items-center'>
                        <h4 className='psheading flex-grow linkcolor' style={{ fontFamily: 'Times New Roman', fontSize: '27px', color: 'black' }}>Create</h4>
                        <Tooltip title="Exit">
                            <Link to="/companyIndex" style={{ color: 'red', textDecoration: 'none',  fontWeight: 'bolder' }}>
                                <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                    Exit <ExitToAppIcon />
                                </Button>
                            </Link>
                        </Tooltip>


                        <Tooltip title="SAVE">

                            <Button onClick={submitData} style={{ color: 'darkolivegreen', fontWeight: 'bolder' , marginLeft:'2px'}} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>

                        </Tooltip>
                    </div>




                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-4 flex">
                        <div className="w-4/5 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                                Company Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={name}
                                // onChange={(e) => setName(e.target.value)}
                                onChange={handleNameChange}
                                type="text"
                                placeholder="Enter Company name"
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="companyCode">
                                Company Code
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={companyCode}
                                onChange={(e) => setCompanyCode(e.target.value)}
                                type="text"
                                placeholder="Enter Company Code"
                                readOnly
                            />
                        </div>
                    </div>


                    <div className="w-full mb-4 flex">

                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="contactNumber1">
                                Contact Number 1
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={contactNumber1} onChange={(e) => setContactNumber1(e.target.value)} type="text" placeholder="Enter Contact Number 1" />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="contactNumber2">
                                Contact Number 2
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={contactNumber2} onChange={(e) => setContactNumber2(e.target.value)} type="text" placeholder="Enter Contact Number 2" />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="email">
                                Email
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={email} onChange={(e) => setEmail(e.target.value)} type="text" placeholder="Enter Email" />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="gstNumber">
                                GST Number
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} maxLength={15} type="text" placeholder="Enter GST Number" />
                        </div>

                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-1/2 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine1">
                                Address Line 1
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={addressLine} onChange={(e) => setAddressLine1(e.target.value)} type="text" placeholder="Enter Address Line 1" />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine2">
                                Address Line 2
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={addressLine2} onChange={(e) => setAddressLine2(e.target.value)} type="text" placeholder="Enter Address Line 2" />
                        </div>

                    </div>
                    <div className="w-full mb-4 flex">
                        <div className="w-1/2 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="PinCode">
                                PIN Code
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={pincode}
                                name="pincode"
                                onChange={(e) => setPostcode(e.target.value)}
                                type="text"
                                placeholder="Enter Pin Code"
                                list="pinCodesList"
                                onBlur={(e) => handlePinCodeChange(e.target.value)} 
                            />
                            <datalist id="pinCodesList">
                                {pinCodes.map((pinCode) => (
                                    <option key={pinCode.Id} value={pinCode.Postcode} />
                                ))}
                            </datalist>
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="City">
                                City
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={city} onChange={(e) => setCity(e.target.value)} type="text" placeholder="Enter City" readOnly />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="District">
                                District
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={district} onChange={(e) => setDistrict(e.target.value)} type="text" placeholder="Enter District" readOnly />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="State">
                                State
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={state} onChange={(e) => setState(e.target.value)} type="text" placeholder="Enter State" readOnly />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="Country">
                                Country
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" value={country} onChange={(e) => setCountry(e.target.value)} type="text" placeholder="Enter Country" readOnly />
                        </div>


                    </div>


                </form>
            </div>
        </Fragment>
    );
}


export default CompanyCreates;


